import { Controller } from '@hotwired/stimulus'

export default class Dropdown extends Controller {
  static targets = ['content']

  manageDropdownState () {
    this.contentTarget.classList.toggle('dropdown__content-open')
  }
}
